


































import { Component, Vue } from 'vue-property-decorator';

import DialogUpdateInformations from '@/components/dialogs/DialogUpdateInformations.vue';
import TermsAndConditions from '@/components/TermsAndConditions.vue';
import Newsletters from '@/components/Newsletters.vue';
import BaseNavbar from '@/components/base/BaseNavbar.vue';
import BaseSidebar from '@/components/base/BaseSidebar.vue';
import EquipmentsGetKitDialog from '@/components/equipments/EquipmentsGetKitDialog.vue';
import EquipmentsConfigureKit from '@/components/equipments/EquipmentsConfigureKitDialog.vue';
import AnalysisRemote from '@/components/analysis/AnalysisRemote.vue';
import DialogStartAnalysisWithoutConnectedStation from '@/components/dialogs/DialogStartAnalysisWithoutConnectedStation.vue';
import AccountConsent from '@/components/account/AccountConsent.vue';
import { orderBy, uniqBy } from 'lodash';

import type { TEntity } from '@/plugins/podolib/services/entities/Entity';
import type { Doctor } from '@/plugins/podolib/services/doctor';

@Component({
  components: {
    DialogUpdateInformations,
    EquipmentsConfigureKit,
    EquipmentsGetKitDialog,
    BaseSidebar,
    BaseNavbar,
    Newsletters,
    TermsAndConditions,
    AnalysisRemote,
    DialogStartAnalysisWithoutConnectedStation,
    AccountConsent,
  },
})
export default class LayoutDashboard extends Vue {
  snackbar: boolean = true;
  interval: any;

  checkConsent() {
    if (Array.isArray(this.$pdc.doctor!.current.consents)) {
      const sortedConsentsByVersion: Required<NonNullable<TEntity<Doctor>['consents']>> = orderBy(
        this.$pdc.doctor!.current.consents,
        (consent) => new Date(consent.version),
        'desc',
      );
      const filteredConsents: Required<NonNullable<TEntity<Doctor>['consents']>> = uniqBy(
        sortedConsentsByVersion,
        (consent) => consent.document,
      );
      filteredConsents.forEach((consent) => {
        if (!consent.consented) {
          console.warn(
            `🔐 Need to consent to the document "${consent.document}" with the version from the "${new Date(
              consent.version,
            ).toUTCString()}"`,
          );
          this.$pdc.bus!.emit('account:consent:open', consent);
        }
      });
    }
  }

  mounted() {
    this.interval = setInterval(() => {
      this.checkConsent();
    }, 900000);

    this.checkConsent();

    this.$pdc.bus!.on('account:consent:closed', this.checkConsent);
  }

  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);

    this.$pdc.bus!.off('account:consent:closed', this.checkConsent);
  }
}
